<template>
  <section class="notification-list-section" :class="{ 'notification-list-section--pc': isPc }">
    <notification-item-parts
      class="notification-list-section__item"
      v-for="notification in notificationList"
      :key="notification.informationId"
      :notification="notification"
      @handlerClickLink="$emit('handlerClickLink', notification)"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'
import NotificationItemParts from '@/components/NotificationPane/NotificationPane/parts/NotificationItemParts.vue'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * Notification リストセクション
 */
export default defineComponent({
  name: 'NotificationListSection',
  components: {
    NotificationItemParts,
  },
  props: {
    notificationList: {
      type: Array as PropType<NotificationItemType[]>,
      default: () => [],
    },
  },
  setup() {
    const isPc = DeviceInfo.isForPC()
    return {
      isPc,
    }
  },
})
</script>

<style lang="scss" scoped>
.notification-list-section {
  width: 100%;
  max-width: 800px;
  border-top: 1px solid $black10;

  &--pc {
    border-top: none;
  }

  &__item {
    border-bottom: 1px solid $black10;
  }
}
</style>
